<template>
  <div class="el-select-tree" ref="ElSelectTree">
    <el-input
      hidden
      aria-hidden
      v-model="inValue"
      readonly
      v-if="false"
    ></el-input>
    <el-popover
      placement="bottom"
      v-model="visible"
      :transition="transition"
      :popper-class="popperClass"
      :width="popoverWidth"
      :disabled="disabled"
      trigger="click"
    >
      <el-tree
        :data="data"
        :filter-node-method="filterNode"
        :node-key="defaultProps['id']"
        ref="selectTree"
        default-expand-all
        :props="defaultProps"
        @node-click="handleNodeClick"
        :current-node-key="inValue"
        :expand-on-click-node="false"
      >
        <div v-if="$scopedSlots.default" slot-scope="{ node, data }">
          <slot :data="data" :node="node"></slot>
        </div>
        <span v-else slot-scope="{ node }" class="el-tree-node__label">{{
          node.label
        }}</span>
      </el-tree>
      <el-input
        class="select-tree-input"
        :placeholder="placeholder"
        v-model="filterText"
        :disabled="disabled"
        :readonly="readonly"
        @mouseenter.native="inputHovering = true"
        @mouseleave.native="inputHovering = false"
        @blur="handleBlur"
        slot="reference"
        @clear="handleClear"
      >
        <i
          v-if="showClear"
          slot="suffix"
          class="el-select__caret el-input__icon el-icon-circle-close"
          @click.stop="handleClear"
        ></i>
        <i
          v-show="!showClear"
          slot="suffix"
          :class="[
            'el-select__caret',
            'el-input__icon',
            'el-icon-' + iconClass
          ]"
        ></i>
        <i
          v-if="filterable"
          slot="prefix"
          class="el-icon-search el-input__icon"
        ></i>
      </el-input>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "ElSelectTree",
  props: {
    value: undefined,
    props: Object,
    disabled: Boolean,
    data: {
      type: Array,
      default: () => []
    },
    transition: {
      type: String,
      default: 'el-zoom-in-top'
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    beforeNodeClick: {
      type: Function,
      default: () => {}
    },
    filterable: {
      type: Boolean,
      default: false
    },
    customClass: String,
    clearable: Boolean
  },
  data() {
    return {
      popoverWidth: 0,
      visible: false,
      selectNode: {},
      filterText: "",
      focus: false,
      inputHovering: false
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val, oldVal) {
        this.$emit("change", val);
        if (this.isEmpty(val)) {
          this.selectNode = {};
          this.filterText = "";
        } else {
          this.$nextTick(() => {
            this.patchValue(val);
          });
        }
        if (!this.isEmpty(oldVal)) {
          this.cancelHighlighted(oldVal);
        }
      }
    },
    filterText(val) {
      if (this.filterable) {
        this.$refs.selectTree.filter(val);
      }
    }
  },
  mounted() {
    this.getParentWidth().then(res => {
      this.popoverWidth = res;
      // console.log(this.selectNode)
    });
  },
  methods: {
    isEmpty(val) {
      return val === void 0 || val === "" || val === null;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleBlur() {
      if (this.isEmpty(this.value)) {
        this.filterText = "";
      }
    },
    getParentWidth() {
      return Promise.resolve(
        this.$refs.ElSelectTree.getBoundingClientRect().width
      );
    },
    handleClear() {
      this.inValue = undefined;
    },
    handleNodeClick(data, node, nodeComponent) {
      this.$emit("node-click", data, node, nodeComponent);
      // 为 node-click 添加一个钩子函数
      if (this.beforeNodeClick) {
        // 从开始点击到执行点击回调之前的钩子函数
        // 返回 false, 则停止执行后续点击回调
        const before = this.beforeNodeClick(data, node, nodeComponent);
        if (before === false) {
          return false;
        }
      }
      const { id } = this.defaultProps;
      this.selectNode = { ...data };
      this.filterText = this.selectNode[this.defaultProps["label"]];
      this.inValue = data[id];
      this.visible = false;
    },
    patchValue(val, data = this.data) {
      const { id, children } = this.defaultProps;
      // label 回显
      for (let i = 0, len = data.length; i < len; i++) {
        const current = data[i];
        if (current[id] === val) {
          this.selectNode = { ...current };
          this.filterText = this.selectNode[this.defaultProps["label"]];
          this.setHighlighted(current[id]);
          break;
        } else {
          if (current[children] && current[children].length) {
            this.patchValue(val, current.children);
          }
        }
      }
    },
    // 设置选中状态
    setHighlighted(val) {
      // console.log('set')
      this.$refs.selectTree.getNode(val).isCurrent = true;
    },
    // 取消选中状态
    cancelHighlighted(val) {
      // console.log('cancel')
      this.$refs.selectTree.getNode(val).isCurrent = false;
    },
    getNode(val) {
      return this.$refs.selectTree.getNode(val);
    }
  },
  computed: {
    inValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    showClear() {
      return this.inputHovering && this.clearable && this.inValue !== void 0;
    },
    iconClass() {
      return this.visible ? "arrow-up is-reverse" : "arrow-up";
    },
    readonly() {
      return !this.filterable;
    },
    defaultProps() {
      return {
        children: "children",
        label: "label",
        id: "id",
        ...this.props
      };
    },
    popperClass() {
      return (
        "el-select-tree_popper" +
        (this.customClass ? ` ${this.customClass}` : "")
      );
    }
  }
};
</script>

<style lang="scss">
.el-select-tree_popper {
  padding: 12px 0;
  .el-tree {
    max-height: 200px;
    overflow: auto;
  }
  .el-tree-node.is-current.is-focusable > .el-tree-node__content {
    color: #17B3A3;
  }
}
.select-tree-input .el-input__inner {
  cursor: pointer;
}
.el-select-tree .el-input .el-select__caret {
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
  cursor: pointer;
  &.is-reverse {
    -webkit-transform: rotateZ(0);
    transform: rotateZ(0);
  }
}
</style>
